import { ensureSession, type SessionInfo } from '@/data/auth';
import { kvGet } from '@/data/db';
import type { Profile } from '@/data/types';

export const ONBOARDING_KEY = 'onboarding.complete';

export interface BootData {
  session: SessionInfo;
  profile: Profile;
  onboardingComplete: boolean;
}

export async function loadSession(): Promise<BootData> {
  const [{ session, profile }, done] = await Promise.all([
    ensureSession(),
    kvGet<boolean>(ONBOARDING_KEY),
  ]);
  return { session, profile, onboardingComplete: done === true };
}

/**
 * Cached boot promise consumed with React 19's `use()`. Kept at module scope so
 * the session is fetched once per page load and suspends the tree instead of
 * being kicked off from an effect.
 */
let cached: Promise<BootData> | null = null;

export function sessionResource(): Promise<BootData> {
  cached ??= loadSession();
  return cached;
}

/** Drops the cache so the next render re-fetches (used after sign-in/out). */
export function invalidateSessionResource(): void {
  cached = null;
}
